import { ImportWithTemplateModal } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import "../../../../../i18n/i18n";

const CONTRACT_DATA_TEMPLATE_FILE_NAME = "fichier_d_import_de_contrats.xlsx";

const CONTRACT_DATA_COLUMNS = [
  "Immatriculation",
  "Référence",
  "Date début contrat (DD/MM/YYYY)",
  "Date fin contrat (DD/MM/YYYY)",
  "Kilométrage contractuel (km)",
  "Coût par km supplémentaire (€)",
];

export type ImportContractDataModalProps = {
  visible: boolean;
  onCloseModal: () => void;
};

export const ImportContractDataModal = (
  props: ImportContractDataModalProps,
) => {
  const { t } = useTranslation();

  return (
    <ImportWithTemplateModal
      visible={props.visible}
      onCloseModal={props.onCloseModal}
      title={t("fleet.advanced_analytics.importContract.title")}
      returnButtonText={t(
        "fleet.advanced_analytics.importContract.button.return",
      )}
      template={{
        fileName: CONTRACT_DATA_TEMPLATE_FILE_NAME,
        columns: CONTRACT_DATA_COLUMNS,
        sheetName: "Contrats",
      }}
      // TODO later
      validateRows={() => []}
      onSubmit={() => console.log("TODO later")}
      errorTypeToLabel={() => ""}
    />
  );
};
